export enum TimePeriod {
    AM = 'AM',
    PM = 'PM'
}
